const numberFormatter = new Intl.NumberFormat("fa-IR");
const dateFormatter = new Intl.DateTimeFormat("fa-IR", { year: "numeric", month: "long", day: "numeric" });

export function formatNumberFa(value: number): string {
  return numberFormatter.format(value);
}

export function formatToman(value: number): string {
  const sign = value < 0 ? "−" : "";
  return `${sign}${numberFormatter.format(Math.abs(value))} تومان`;
}

export function formatRelativeTime(iso: string): string {
  const date = new Date(iso);
  const diffMs = Date.now() - date.getTime();
  if (Number.isNaN(diffMs)) return "";

  const diffMinutes = Math.round(diffMs / 60_000);
  if (diffMinutes < 1) return "لحظاتی پیش";
  if (diffMinutes < 60) return `${formatNumberFa(diffMinutes)} دقیقه پیش`;

  const diffHours = Math.round(diffMinutes / 60);
  if (diffHours < 24) return `${formatNumberFa(diffHours)} ساعت پیش`;

  const diffDays = Math.round(diffHours / 24);
  if (diffDays < 30) return `${formatNumberFa(diffDays)} روز پیش`;

  return dateFormatter.format(date);
}
